module.exports = __webpack_public_path__ + "media/images/icons/facebook_share-f3d7616f501ae42f56db9cc11bb7c645.svg";